module.exports = __webpack_public_path__ + "img/adv-ca.7bbefca.jpg";